import { Component, input, signal } from '@angular/core';

import type { AggregatedEvaluationsSkill } from '@core/evaluations-types';
import { BoxComponent, IconComponent, RtTooltip } from '@core/user-interface-legacy';

import { EvaluationSkillBadgeComponent } from '../evaluation-skill-badge/evaluation-skill-badge.component';
import { EvaluationSkillRatingsComponent } from '../evaluation-skill-ratings/evaluation-skill-ratings.component';
import { EvaluationSkillScaleRatingComponent } from '../evaluation-skill-scale-rating/evaluation-skill-scale-rating.component';

@Component({
  selector: 'rt-evaluation-skill',
  templateUrl: './evaluation-skill.component.html',
  styleUrl: './evaluation-skill.component.less',
  imports: [
    BoxComponent,
    EvaluationSkillBadgeComponent,
    EvaluationSkillRatingsComponent,
    EvaluationSkillScaleRatingComponent,
    IconComponent,
    RtTooltip,
  ],
})
export class EvaluationSkillComponent {
  protected readonly isCollapsed = signal(true);

  public skill = input.required<AggregatedEvaluationsSkill>();

  protected toggle(): void {
    this.isCollapsed.update(isCollapsed => !isCollapsed);
  }
}
